import React from 'react';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import ProductDetailPanel from '../../ProductDetailPanel';
import CustomAttributeInput from './CustomAttributeInput';
import { ContainerStyle, EmptyMessageStyle, AttributeListStyle } from './styles';
import { PRODUCT_DETAIL_PAGE_PANEL_NAME } from '../../../../../constants/service/app/productConstants';
import { CustomAttribute } from '../../../../../types/product/customAttribute';

interface ProductCustomAttributeProps {
  form: WrappedFormUtils;
  isEditable?: boolean;
  initialValue?: CustomAttribute[];
}

/**
 * 상품 커스텀 속성 컨테이너 컴포넌트
 * controlType과 dataType에 따라 동적으로 입력 컴포넌트를 렌더링합니다
 * 메인 form에 통합되어 validation이 자동으로 처리됩니다
 */
const ProductCustomAttribute: React.FC<ProductCustomAttributeProps> = ({
  form,
  isEditable = true,
  initialValue = [],
}) => {
  return (
    <ProductDetailPanel title="커스텀 속성" name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_CUSTOM_ATTRIBUTE}>
      <ContainerStyle>
        {initialValue.length === 0 ? (
          <EmptyMessageStyle>커스텀 속성이 없습니다.</EmptyMessageStyle>
        ) : (
          <AttributeListStyle>
            {initialValue.map((attribute) => (
              <CustomAttributeInput key={attribute.key} attribute={attribute} form={form} isEditable={isEditable} />
            ))}
          </AttributeListStyle>
        )}
      </ContainerStyle>
    </ProductDetailPanel>
  );
};

export default ProductCustomAttribute;
